import OMOPlayLogo from "../assets/images/logo_omoplay_black.svg";
import IconCheck from "../assets/images/icon.check.green.svg";
import {Button} from "omoplay";
import {useSearchParams} from "react-router-dom";


const DuplicateAccount = () => {
    const [query] = useSearchParams()

    return (
        /* 모바일 레이아웃 — 상세 설명은 `JoinPage.js` 주석 참고(`h-screen`+중앙정렬 → `100dvh`+`m-auto`) */
        <div className="w-full min-h-screen min-h-[100dvh] flex login-background-gradient">
            <div className="flex-1 bg-white flex">
                <div className="m-auto w-full max-w-[420px] px-5 py-8 flex-col items-center">
                <div className="flex-col items-center text-center">
                    <div className="flex justify-center" style={{marginBottom: "20px"}}>
                        <img alt="" src={OMOPlayLogo} className="w-full max-w-[272px] h-auto" />
                    </div>
                    <div style={{marginBottom: "43px"}}>NO.1 온오프라인 브랜드사 고객 마케팅 서비스</div>
                    <div className="text-[24px] font-medium">계정 통합</div>
                    <div><img src={IconCheck} alt="Check" width={100} height={100} /></div>
                    <div className="font-medium">기존에 가입한 계정이 존재합니다.</div>
                    <div className="font-medium">아래 계정과 통합되었습니다.</div>
                    <div className="font-bold font-20px">{query.get("account")}</div>
                    <Button variants="primary" size="large" onClick={() => window.location.href = "/login"}
                            value="다시 로그인하기" style={{marginTop: "16px", width: "100%", maxWidth: "320px"}} />
                </div>
                </div>
            </div>
        </div>
    )
}

export default DuplicateAccount